define("shared/components/shared/mavely/logo-badge", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isVisible}}
    <div
      class="tAC--group__mavelyProfile {{if @compact 'tAC--group__mavelyProfile--compact'}}"
      data-test-id="mavely-logo-badge"
      ...attributes
    >
      <span aria-hidden="true" class="tAC--group__mavelyDivider"></span>
      <span class="tAC--group__mavelyLogo">
        {{svg-jar "mavely-emoji"}}
        <EmberTooltip @event="hover" @popperContainer="body" @tooltipClass="tooltip">
          {{#each this.profiles as |profile|}}
            <div>{{profile.email}}</div>
          {{/each}}
        </EmberTooltip>
      </span>
    </div>
  {{/if}}
  */
  {
    "id": "Iy2G+PDz",
    "block": "[[[41,[30,0,[\"isVisible\"]],[[[1,\"  \"],[11,0],[16,0,[29,[\"tAC--group__mavelyProfile \",[52,[30,1],\"tAC--group__mavelyProfile--compact\"]]]],[24,\"data-test-id\",\"mavely-logo-badge\"],[17,2],[12],[1,\"\\n    \"],[10,1],[14,\"aria-hidden\",\"true\"],[14,0,\"tAC--group__mavelyDivider\"],[12],[13],[1,\"\\n    \"],[10,1],[14,0,\"tAC--group__mavelyLogo\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"mavely-emoji\"],null]],[1,\"\\n      \"],[8,[39,2],null,[[\"@event\",\"@popperContainer\",\"@tooltipClass\"],[\"hover\",\"body\",\"tooltip\"]],[[\"default\"],[[[[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"profiles\"]]],null]],null],null,[[[1,\"          \"],[10,0],[12],[1,[30,3,[\"email\"]]],[13],[1,\"\\n\"]],[3]],null],[1,\"      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@compact\",\"&attrs\",\"profile\"],false,[\"if\",\"svg-jar\",\"ember-tooltip\",\"each\",\"-track-array\"]]",
    "moduleName": "shared/components/shared/mavely/logo-badge.hbs",
    "isStrictMode": false
  });
  let MavelyLogoBadgeComponent = _exports.default = (_class = class MavelyLogoBadgeComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "mavelyAuth", _descriptor, this);
    }
    get profiles() {
      const siId = this.args.socialIdentity?.id;
      if (!siId) return [];
      return this.mavelyAuth.mavelyProfiles.all.filter(p => p.socialIdentityIds.includes(siId) && p.connectionId != null);
    }
    get isVisible() {
      return this.profiles.length > 0;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "mavelyAuth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyLogoBadgeComponent);
});